import React, { useState } from "react";
import DropBox from "/@src/components/newComponents/DropBox";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { saveMedia } from "/@src/redux/media/actions";
import { closeModal } from "/@src/redux/modal/actions";
import IntlMessages from "/@src/helpers/IntlMessages";
import { getExpectedFileTypes } from "/@src/constants/mediaTypes";
import RenderMedia from "/@src/components/newComponents/RenderMedia";
import useFeature from "/@src/hooks/useFeature";

function AddNewMedia({ allowedType, onCancel, onUpload, type }) {
  const { hasFeature, upgradePlanModal } = useFeature("storageAllowedMB");
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [url, setUrl] = useState("");
  const [file, setFile] = useState("");
  const [error, setError] = useState("");

  const onDrop = (acceptedFiles) => {
    setError("");

    if (acceptedFiles.length) {
      const file = acceptedFiles[0];
      const fileExtension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      const validExtensions = [
        ".glb",
        ".gltf",
        ".jpg",
        ".png",
        ".jpeg",
        ".webp",
        ".mp4",
        ".mov",
        ".svg",
      ];

      if (!allowedType && !type && !validExtensions.includes(fileExtension)) {
        setError(
          <span>
            Incorrect file type
            <br />
            Expected file formats: {validExtensions.join(", ")}.
          </span>
        );
        return;
      }

      setFile(file);
      setUrl(URL.createObjectURL(file));
      setIsEdit(false);
      return;
    }

    const mediaParams = {
      mediaType: type,
      allowedTypesArr: allowedType,
    };
    const expectedFormats = getExpectedFileTypes(mediaParams);
    setError(
      <span>
        Incorrect file type
        <br />
        Expected file formats: {expectedFormats.join(", ")}.
      </span>
    );
  };

  const save = async () => {
    if (!hasFeature) {
      upgradePlanModal("storageAllowedMB");
      return;
    }
    setIsSaving(true);

    dispatch(saveMedia(file, "Media Uploaded Successfully"))
      .then((res) => {
        if (res?.mediaId) {
          onUpload(res);
        }
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const canSave = () => {
    return file && !error;
  };

  return (
    <div>
      {isEdit && (
        <DropBox onDrop={onDrop} onCancel={onCancel} accept={allowedType} />
      )}
      {!isEdit && file && (
        <div
          style={{ minHeight: "200px"}}
          className="d-flex flex-column place-items-center"
        >
          <h5 className="m-auto">
            File: <strong>{file.name}</strong>
          </h5>
          <div className="preview mx-auto mt-1" style={{ maxWidth: "200px" }}>
            <RenderMedia url={url} mimeType={file.type} mediaStyles={{maxHeight: '200px'}} />
          </div>
        </div>
      )}
      {error && <div className="error-msg mt-2">{error}</div>}
      <div className="top-right-button-container">
        {file && (
          <Button
            color="secondary"
            outline
            className="mt-4"
            onClick={() => {
              setIsEdit(true);
              setFile(null);
            }}
          >
            Change
          </Button>
        )}
        <Button
          color="primary"
          onClick={save}
          className={`btn-shadow btn-multiple-state mt-4 ml-2 ${
            isSaving ? "show-spinner" : ""
          }`}
          disabled={!canSave()}
        >
          <span className="spinner d-inline-block">
            <span className="bounce1" />
            <span className="bounce2" />
            <span className="bounce3" />
          </span>
          <span className="label">
            <IntlMessages id="button.upload-media" />
          </span>
        </Button>
      </div>
    </div>
  );
}

export default AddNewMedia;
